import { CheckCircle } from '@mui/icons-material';
import { ButtonCommon } from '../Button/ButtonCommon';

const NotificationModal = ({
  title,
  label,
  buttonLabel,
  onClick,
}: {
  title: string;
  label: string;
  buttonLabel: string;
  onClick?: () => void;
}) => {
  return (
    <div className='w-[420px] rounded-[16px] p-[24px] flex flex-col gap-[24px] justify-center bg-[var(--bgWhite50)]'>
      <div className='mx-auto'>
        <CheckCircle sx={{ fontSize: 64 }} className='text-[var(--sematicSuccessColor)]' />
      </div>
      <div className='text-center gap-[4px] flex flex-col'>
        <h3 className='text-[24px] font-[700] leading-[32px] text-[var(--textBlack)] whitespace-nowrap'>{title}</h3>
        <p
          className='text-[var(--textGray)] font-[400] text-[14px] leading-[22px]'
          dangerouslySetInnerHTML={{ __html: label || '' }}
        ></p>
      </div>
      <div>
        <ButtonCommon fullWidth={true} size='md' color='basic' radius='rounded' onClick={onClick}>
          {buttonLabel}
        </ButtonCommon>
      </div>
    </div>
  );
};

export default NotificationModal;
